// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nd-0";
export var assigneeDetails = "_nd-1";
export var assigneeInfo = "_nd-2";
export var dropdownContainer = "_nd-4";
export var dropdownImage = "_nd-5";
export var editAssigneeInfo = "_nd-3";
export var editAssigneeModalContainer = "_nd-6";
export var hidden = "_nd-8";
export var input = "_nd-7";